import type { FaireProductEntity } from "../../entity_types/product";

export const p_re82ea97bc: FaireProductEntity = {
  token: "p_re82ea97bc",
  type: "product",
  name: "Thank You From The Bottom Of My Heart greeting card",
  brandToken: "b_34720aeb",
  brandName: "Richie Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/4e81d014b74ef410d6ede6787c768b8dca3732febc0eaa3d08d9ffdc40785650.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    "Sometimes you've got to say a little more than just a thank you. This one is it!\n\n• One color letterpress print\n• Front greeting: \"Thank you from the bottom of my heart\".\n\n• Printed on beautiful 100% cotton paper, fluffy and yummy to write on. The cotton used is left over from the garment industry so it's recycled and earth friendly!\n• Inside greeting: blank.\n\n• A2 size, paired with a neon pink envelope.\n• Packaged in a clear sleeve.\n\nThank You From The, Bottom Of My Heart Card, minimalist note card, modern thank you, card for friend, hostess card, hostess gifts, boho thank you card, nurse thank you card, doctor thank you card, boss thank you card, thank you mom and dad, wedding planner gift",
  tags: [],
  msrpDollars: 6.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:30.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
